/* eslint-disable */
export class CompileError extends Error {
    constructor(
        public message: string,
        public startPos: { line: number, column: number } | { eof: true, line?: never, column?: never },
        public endPos: { line: number, column: number } | { eof: true, line?: never, column?: never },
    ) {
        super(message);
    }
}

export class PreprocessorCompileError extends CompileError { }

export class TokenizerCompileError extends CompileError { }

export class AstCompileError extends CompileError { }

export class AstCompileWarning {
    constructor(
        public message: string,
        public startPos: { line: number, column: number } | { eof: true, line?: never, column?: never },
        public endPos: { line: number, column: number } | { eof: true, line?: never, column?: never },
    ) {}
}